module.exports = __webpack_public_path__ + "img/icon_element_active.c064b8da.svg";